import { currentFromDate, currentToDate } from "@/services/DateServices";

// Por defecto los listados muestran SOLO el mes en curso. Este filtro de mes
// es implícito (la vista por defecto), NO un filtro aplicado por el usuario, por
// eso el badge del botón de filtros NO lo cuenta (ver activeCount en DrawerFilter).
// Cada mes la vista se "resetea" sola: el día 1 from/to apuntan al nuevo mes.
const documentFilters = {
  keyRangeDates: "currentMonth",
  from: currentFromDate, // inicio del mes actual
  to: currentToDate, // fin del mes actual
  status: null,
  search: null,
  orderBy: null,
  clientId: null
};

export default {
  state: {
    modules: {
      catalog: {
        product: {
          add: {
            name: "",
            description: "",
            code: "",
            amount: "",
            is_stock_counter: false,
            image: ""
          }
        }
      },
      sales: {
        documents: {
          quotes: {
            filters: {
              get: documentFilters
            }
          },
          invoices: {
            filters: {
              get: {
                ...documentFilters,
                ...{
                  is_paid: null
                }
              }
            }
          },
          creditNotes: {
            filters: {
              get: documentFilters
            }
          },
          debitNotes: {
            filters: {
              get: documentFilters
            }
          },
          withholdings: {
            filters: {
              get: documentFilters
            }
          },
          payments: {
            filters: {
              get: documentFilters
            }
          },
          liquidations: {
            filters: {
              get: documentFilters
            }
          },
          remissions: {
            filters: {
              get: documentFilters
            }
          }
        }
      }
    },
    notification: false,
    // Preferencias de vista persistentes
    viewPreferences: {
      salesDocuments:
        localStorage.getItem("mydessk_salesDocuments_viewMode") || "board",
      directory: localStorage.getItem("mydessk_directory_viewMode") || "grid",
      contacts: localStorage.getItem("mydessk_contacts_viewMode") || "grid",
      products: localStorage.getItem("mydessk_products_viewMode") || "list",
      categories: localStorage.getItem("mydessk_categories_viewMode") || "list",
      movements: localStorage.getItem("mydessk_movements_viewMode") || "list"
    }
  },
  mutations: {
    setSalesDocumentsFiltersGet: (state, { documentKey, data }) => {
      state.modules.sales.documents[documentKey].filters.get = data;
    },
    updateNotification(state, value) {
      state.notification = value;
    },
    setViewPreference(state, { key, value }) {
      state.viewPreferences[key] = value;
      localStorage.setItem("mydessk_" + key + "_viewMode", value);
    }
  },
  actions: {
    salesDocumentsFiltersGet({ state, commit }, { documentKey, filters }) {
      const getFilters = state.modules.sales.documents[documentKey].filters.get;

      commit("setSalesDocumentsFiltersGet", {
        documentKey,
        data: {
          ...getFilters,
          ...filters
        }
      });
    },

    sendNotification({ commit }, value) {
      commit("updateNotification", value);
    },

    setViewPreference({ commit }, payload) {
      commit("setViewPreference", payload);
    }
  },
  getters: {
    getModule: state => module => {
      return state.modules[module];
    },
    getNotification: state => state.notification,
    getViewPreference: state => key => state.viewPreferences[key]
  }
};
